import Axios from './APIService';
import { AxiosPromise } from 'axios';

import User from '@/types/User';
import SignIn from '@/form/SignIn';
import ResetPassword from '@/form/ResetPassword';
import NewPassword from '@/form/NewPassword';
import CollectedProduct from '@/types/CollectedProduct';

const apiBase = '/users';

const UserAPI = {

    getAllUsers(page: number, limit: number): AxiosPromise<User[]> {
        return Axios.get(`/admin${apiBase}?page=${page}&limit=${limit}`);
    },

    authenticate(): AxiosPromise<User> {
        return Axios.get(`${apiBase}/authenticate`);
    },

    signIn(signIn: SignIn): AxiosPromise<User> {
        return Axios.post(`${apiBase}/signin`, signIn);
    },

    validate(validateCode: string): AxiosPromise<User> {
        return Axios.get(`${apiBase}/validate/${validateCode}`);
    },

    resetPassword(form: ResetPassword): AxiosPromise<string> {
        return Axios.post<string>(`${apiBase}/password/reset`, form);
    },

    setPassword(form: NewPassword): AxiosPromise<string> {
        return Axios.post<string>(`${apiBase}/password/set`, form);
    },

    signUp(user: User, language: string): AxiosPromise<User> {
        return Axios.post(`${apiBase}?language=${language}`, user);
    },

    update(user: User): AxiosPromise<User> {
        return Axios.put(`${apiBase}`, user);
    },

    signOut(): AxiosPromise<User> {
        return Axios.post(`${apiBase}/signout`);
    },

    postLike(productId: string): AxiosPromise<User> {
        return Axios.post(`${apiBase}/likes/${productId}`);
    },

    deleteLike(productId: string): AxiosPromise<User> {
        return Axios.delete(`${apiBase}/likes/${productId}`);
    },

    postCollect(productId: string): AxiosPromise<User> {
        return Axios.post(`${apiBase}/collection/${productId}`);
    },

    putCollectProduct(productId: string, collectedProduct: CollectedProduct): AxiosPromise<User> {
        return Axios.put(`${apiBase}/collection/${productId}`, collectedProduct);
    },

    deleteCollect(productId: string): AxiosPromise<User> {
        return Axios.delete(`${apiBase}/collection/${productId}`);
    },

    acceptEmailStatus(emailType: string): AxiosPromise<User> {
        return Axios.post(`${apiBase}/email/${emailType}`);
    },

    deleteEmailStatus(emailType: string): AxiosPromise<User> {
        return Axios.delete(`${apiBase}/email/${emailType}`);
    },

    postCollectAccess(): AxiosPromise<User> {
        return Axios.post(`${apiBase}/collection`);
    },

    deleteCollectAccess(): AxiosPromise<User> {
        return Axios.delete(`${apiBase}/collection`);
    },

    patchUser(userId: string, user: User): AxiosPromise<User> {
        return Axios.patch(`${apiBase}/${userId}`, user);
    }

};

export default UserAPI;
